import { css, Theme } from '@emotion/react'
import { alpha, alertClasses, buttonBaseClasses } from '@mui/material'

export const alert = (theme: Theme) => css`
  margin-bottom: 14px;
  padding: 16px;
  border-radius: 16px;
  line-height: 1.75em;
  align-items: flex-start;

  &.${alertClasses.standard}.${alertClasses.colorError} {
    color: ${theme.colors.red};
    background: ${alpha(theme.colors.red, 0.1)};

    & .${buttonBaseClasses.root}:hover {
      background: ${alpha(theme.colors.red, 0.15)};
    }
  }

  & .${alertClasses.message} {
    padding: 0;
  }

  & .${alertClasses.action} {
    margin: 0 0 0 auto;
    padding: 0;
    align-items: center;
  }

  & .${buttonBaseClasses.root} {
    width: 24px;
    height: 24px;
    padding: 0;
  }
`
